module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Semibold.232f10e7c418b7d10a34d325d76dadbb.ttf";